import { ArrowLeftIcon } from '@phosphor-icons/react'

import { IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Header = ({ title, onBack }) => {
  return (
    <Styles.Container>
      <Styles.BackContainer>
        {onBack && <IconButton onClick={onBack} icon={<ArrowLeftIcon size={24} />} variant="text" />}
      </Styles.BackContainer>
      <Text type="titleM">{title}</Text>
      <Styles.BackContainer />
    </Styles.Container>
  )
}

export default Header
